import { Image } from "./image";
import React, { useState } from "react";

function PortfolioItem({ d }) {
  const [isHover, setIsHover] = useState(false);

  const handleClick = () => { 
    window.open(d.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className="col-sm-6 col-md-4 col-lg-4"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
     
      <Image
        title={isHover ? d.url : d.title}
        largeImage={null} 
        smallImage={d.smallImage}
        disableLink={true} 
      />
    </div>
  );
}

export const Gallery = (props) => (
  <div id="portfolio" className="text-center">
    <div className="container">
      <div className="section-title">
        <h2>They Trust TechFief</h2>
        <p>Driving growth and innovation for our clients—one project at a time.</p>
      </div>
      <div className="row">
        <div className="portfolio-items">
          {props.data
            ? props.data.map((d, i) => (
                <PortfolioItem key={`${d.title}-${i}`} d={d} />
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  </div>
);
